const getters = {
  isSNS: state => state.user.isSNS,
  avatar: state => state.user.avatar,
  appid: state => state.user.appid,
  catch_components:state=>state.user.catch_components
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js